import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';

export class ClienteGrupoEconomicoFilter implements Filter {
    nome: string;
    situacao: number;
    idsRepresentantes: number[] = [];
    somenteRepresentantesAtivos = true;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Nome
        if (this.nome) {
            params = params.append('nome', this.nome);
        }
        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }
        // Representantes
        if (this.idsRepresentantes && this.idsRepresentantes.length > 0) {
            this.idsRepresentantes.forEach(id => {
                params = params.append('idRepresentante', id.toString());
            });
        }

        return params;
    }

    clear() {
        this.nome = null;
        this.situacao = null;
        this.idsRepresentantes = [];
        this.somenteRepresentantesAtivos = true;
    }
}
